module.exports = __webpack_public_path__ + "img/toplogo.dc1ca84f.png";